import React from "react";

var UsersIcon = function UsersIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 12c3.032 0 5.5-2.467 5.5-5.5S10.532 1 7.5 1 2 3.467 2 6.5 4.468 12 7.5 12zm9.5 0c2.757 0 5-2.243 5-5s-2.243-5-5-5a4.96 4.96 0 0 0-2.899.942A7.458 7.458 0 0 1 15 6.5a7.454 7.454 0 0 1-1.306 4.222A4.96 4.96 0 0 0 17 12zm-.5 2c-.496 0-.981.037-1.45.103 1.829 1.329 2.95 3.185 2.95 5.272V23h6v-3.625C24 16.411 20.636 14 16.5 14zM8 14c-4.411 0-8 2.411-8 5.375V23h16v-3.625C16 16.411 12.412 14 8 14z"
  }));
};

UsersIcon.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
UsersIcon.defaultProps.solid = true;
export default UsersIcon;